import React, { createContext, useContext, useState, useCallback } from 'react';

interface ChatSessionContextType {
    refreshTrigger: number;
    triggerRefresh: () => void;
}

const ChatSessionContext = createContext<ChatSessionContextType | undefined>(undefined);

export const ChatSessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const triggerRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    return (
        <ChatSessionContext.Provider value={{ refreshTrigger, triggerRefresh }}>
            {children}
        </ChatSessionContext.Provider>
    );
};

export const useChatSession = () => {
    const context = useContext(ChatSessionContext);
    if (context === undefined) {
        throw new Error('useChatSession must be used within a ChatSessionProvider');
    }
    return context;
};
